// Third party modules;
import React from 'react';

// HelpBot modules;
import api from './api/api';
import app from './app';
import { Form, FORM, form_close } from './Form';

const info2data = (info) => {

   var data = [];

   if (!info || !info.length) return data;

   for (var ith = 0; ith < info.length; ith++) {

      var text = info[ith];

      switch (text[0]) {
      case 'A':
         data[data.length-1].text += '(' + text.substr(1) + ')';
         break;
      case 'L':
         data[data.length] = { type: 'l', text: text.substr(1) };
         break;
      case 'O':
         //html += '<ol>';
         break;
      case 'P':
         data[data.length] = { type: 'p', text: text.substr(1) };
         break;
      case 'U':
         //html += '<ul>';
         break;
      case 'a':
         data[data.length-1].text += '[' + text.substr(1) + ']';
         break;
      case 'c':
         data[data.length-1].text += text.substr(1);
         break;
      case 'l':
         //html += '</li>';
         break;
      case 'o':
         //html += '</ol>';
         break;
      case 'p':
         //html += '</p>'
         break;
      case 'u':
         //html += '</ul>';
         break;
      default:
      }
   }
   return data;

} // info2data();

const Item = ({ data, edit, index, set_data, set_edit, ...props }) => {

   const item_ref = React.useRef();

   React.useEffect(
      () => {
         item_ref.current.innerHTML = data[index].text;
         if (edit === index) item_ref.current.focus();
      },
      [data, index]
   );

   const on_focus = (event, index, set_edit) => {
      set_edit(index);
   }; // on_focus();

   const on_input = (event, index, data) => {
      const new_data = [...data];
      new_data[index].text = event.target.innerText;
   }; // on_input();

   const on_key_down = (event, index, data) => {
      const selection     = window.getSelection();
      const cursor_offset = selection.anchorOffset;
      if (('Backspace' === event.key) && index) {
         if (0 < cursor_offset) return;
         event.preventDefault();
         data[index-1].text += ' ' + data[index].text;
         set_data(remove_item(data, index));
         set_edit(index - 1);
      } else if (('Delete' === event.key) && (index < (data.length - 1))) {
         if (cursor_offset < data[index].text.length) return;
         event.preventDefault();
         data[index].text += ' ' + data[index + 1].text;
         set_data(remove_item(data, index + 1));
      } else if ('Enter' === event.key) {
         event.preventDefault();
         const new_text   = data[index].text.substr(cursor_offset);
         const new_data   = [ ...data.slice(0, index + 1), { type: data[index].type, text: new_text }, ...data.slice(index + 1) ];
         data[index].text = data[index].text.substr(0, cursor_offset);
         set_data(new_data);
         set_edit(index + 1);
      } else if (event.ctrlKey) {
         if ('~' === event.key) {
            event.preventDefault();
            const new_data = [...data];
            new_data[index].type = ('p' === new_data[index].type) ? 'l' : 'p';
            set_data(new_data);
         }
      }
   }; // on_key_down();

   const remove_item = (data, index) => {
      // IF remove first item:
      if (0 === index) return [ ...data.slice(1) ];
      // IF remove last item;
      if (index === (data.length - 1)) return [ ...data.slice(0, index) ];
      return [ ...data.slice(0, index), ...data.slice(index + 1) ];
   }; // remove_item();

   // console.log('Item:index=' + index, ' type=', data[index].type);

   if ('p' === data[index].type) {
      var style = { padding: '2px', marginBottom: '2px' };
   } else {
      var style = { padding: '2px', margin: '0 0 2px 15px' };
   }

   const Tag = 'p' === data[index].type ? 'p' : 'li';

   return(
      <Tag
        className="ask-henry-form-intent-edit-html"
        ref={item_ref}
        contentEditable="true"
        onFocus={(e) => on_focus(e, index, set_edit)}
        onInput={(e) => on_input(e, index, data)}
        onKeyDown={(e) => on_key_down(e, index, data)}
        spellCheck="false"
        style={style}
      />
   );

} // Item();

const EditIntent = () => {

   // Flow:
   //   BUILD form to get intent name
   //   CHECK user input
   //   ENACT fetch of file then go back to BUILD state
   //   BUILD form with intent info

   const [edit, set_edit] = React.useState(0);
   const [file, set_file] = React.useState(null);

   const build = ({ set_body, set_data, set_foot, data, warn, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;

      if (!file) {

         set_body(
            <>
               {warn}
               <p className="ask-henry-body-margin-bottom-x">Enter intent to edit:</p>
               <input className="ask-henry-form-input" placeholder="Intent. . ." ref={intent} type="text" />
            </>
         );

         set_foot(
            <>
              <button className="ask-henry-form-button" type="submit">Edit</button>
              <button className="ask-henry-form-button" onClick={form_close} >Cancel</button>
            </>
         );

      } else {

         set_body(
            <>
               <div className="ask-henry-form-intent-edit-scroll">
                 {data.map((item, index, data) => {
                    return <Item data={data} edit={edit} index={index} key={key_index++} set_data={set_data} set_edit={set_edit} />;
                 })}
               </div>
            </>
         );

         set_foot(
            <>
              <button className="ask-henry-form-button" type="submit">Save</button>
              <button className="ask-henry-form-button" onClick={form_close} >Cancel</button>
            </>
         );

      }

   } // build();

   const check = ({ set_form, set_warn, ...args }) => {
      // The check() function validates the user input, if the input is bogus, a warning message
      // is set, otherwise the form state is set to ENACT;
      if (!intent.current?.value) {
         set_warn('Enter intent before you click the EDIT button.');
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else {
         set_file(intent.current?.value);
         set_form(FORM.ENACT);// Send any requests to the API;
      }
   } // check();

   const enact = async ({ set_data, set_form, set_warn, data, ...args }) => {
      // The enact() function does the actual work given the user inputs and options;
      var response = await api.fetch('dbs/info/fetch/' + app.state.user_access_list[app.state.user_access_id].version_id + '/' + intent.current?.value, api.post());
      if (!response.good) {
         if (404 === response.stat) {
            set_file(null);
            set_warn('undefined' === typeof response.data.text ? 'Unrecognized API errror.' : response.data.text);
         } else {
         }
      } else {
         const info = response.data.info;
         var   data = info2data(info);
         set_data(data);
      }
      set_form(FORM.BUILD);
   } // enact();

   const final = ({ set_body, set_foot, ...args }) => {
      // The final() function displays the final results and renders the close option;
      set_body(<p className="ask-henry-body-margin-bottom-x"></p>);
      set_foot(<button className="ask-henry-form-button" onClick={form_close} >Close</button>);
   } // final();

   const intent  = React.useRef();

   var key_index = 1;

   return <Form build={build} check={check} class_string="ask-henry-form-intent-edit" enact={enact} final={final} title={'Edit ' + (file ? file : 'Intent')} />

} // <EditIntent />;

export default EditIntent;
